import { ModuleEnum, RegionsEnum } from '../../generated/operations';
import { h } from '@stencil/core';
import { MESSAGES, PATH } from 'src/components/constants';
import { DesignTypes } from 'src/types/DesignTypes';
import { store } from 'src/utils/store';
import { createClickHandler } from 'src/components/functional/createClickHandler';

type Props = {
  isMobile: boolean;
}

export const RenderHomePage = ({ isMobile }: Props) => [
  (
    <div class="page page--home-page">
      <div class="card">
        <h2>
          <belimo-i18n messageId={MESSAGES.SEARCH}/>
        </h2>
        <div class="card__note">
          <div class="note">
            <belimo-i18n messageId={MESSAGES.HELP_TEXT_FOR_GLOBAL_SEARCH}/>
          </div>
        </div>
        <app-search/>
      </div>
      <div class="card">
        <h2>
          <belimo-i18n messageId={MESSAGES.SEARCH_BY_PARAMETERS}/>
        </h2>
        <div class="card__note">
          <div class="note">
            <belimo-i18n messageId={MESSAGES.SELECT_PRODUCT_TYPE}/>
          </div>
        </div>
        {isMobile ? (
          <div class="selection">
            <div class="selection-box">
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Air}/1`}
                                    onClick={createClickHandler(ModuleEnum.Air)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'air2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Air}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.AIR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              {store.state.currentRegion === RegionsEnum.Am && (<div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${ModuleEnum.FireAndSmoke}`}
                                    onClick={createClickHandler(ModuleEnum.FireAndSmoke + 'Selection')}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'fire'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.FireAndSmoke}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.AIR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>)}
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Sensor}/1`}
                                    onClick={createClickHandler(ModuleEnum.Sensor)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'sensor2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Sensor}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.SENSOR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>

              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Water}/1`}
                                    onClick={createClickHandler(ModuleEnum.Water)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'actuator2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.WATER_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.WaterByValve}/1`}
                                    onClick={createClickHandler(ModuleEnum.WaterByValve)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'valve2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={ModuleEnum.WaterByValve}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FIND_BY_DESIGN}/${DesignTypes.Square}/1`}
                                    onClick={createClickHandler(ModuleEnum.FindByDesign)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'design2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={ModuleEnum.FindByDesign}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
            </div>
          </div>
        ) : (
          <div class="selection">
            <div class="selection-box">
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Air}/1`}
                                    onClick={createClickHandler(ModuleEnum.Air)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'air2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Air}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.AIR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              {store.state.currentRegion === RegionsEnum.Am && (<div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${ModuleEnum.FireAndSmoke}`}
                                    onClick={createClickHandler(ModuleEnum.FireAndSmoke + 'Selection')}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'fire'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.FireAndSmoke}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.AIR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>)}
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Sensor}/1`}
                                    onClick={createClickHandler(ModuleEnum.Sensor)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'sensor2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Sensor}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.SENSOR_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
            </div>

            <div class="selection-box">
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.Water}/1`}
                                    onClick={createClickHandler(ModuleEnum.Water)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'actuator2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={MESSAGES.WATER_REPLACEMENTS}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FILTER}/${ModuleEnum.WaterByValve}/1`}
                                    onClick={createClickHandler(ModuleEnum.WaterByValve)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'valve2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={ModuleEnum.WaterByValve}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
              <div class="selection-box__slot">
                <stencil-route-link url={`${store.state.root}${PATH.FIND_BY_DESIGN}/${DesignTypes.Square}/1`}
                                    onClick={createClickHandler(ModuleEnum.FindByDesign)}
                                    class="selection-item selection-item--big">
                  <div class="selection-item__img">
                    <belimo-svg-sprite svgId={'design2'}/>
                  </div>
                  <div class="selection-item__title">
                    <h2>
                      <belimo-i18n messageId={ModuleEnum.Water}/>
                    </h2>
                    <p>
                      <belimo-i18n messageId={ModuleEnum.FindByDesign}/>
                    </p>
                  </div>
                  <div class="selection-item__icon">
                    <belimo-svg-sprite svgId={'delimiter'}/>
                  </div>
                </stencil-route-link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
]
